import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "nameInitials",
})
export class NameInitialsPipe implements PipeTransform {
  transform(fullName: string): string {
    const nameParts = fullName.split(" ");
    const firstNameInitial = nameParts[0]?.charAt(0)?.toUpperCase() ?? "";
    const lastNameInitial =
      nameParts.length > 1
        ? (nameParts.pop()?.charAt(0)?.toUpperCase() ?? "")
        : "";
    return firstNameInitial + lastNameInitial;
  }
}
